module.exports = __webpack_public_path__ + "static/media/ser_bar_fen_hoa.7bd7ea60.png";